import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-trekking',
  templateUrl: './trekking.component.html',
  styleUrls: ['./trekking.component.css']
})
export class TrekkingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
